<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tabs/home" text=""></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" scrollY="true">
  <ng-container *ngIf="!loading else showLoading">
    <div class="hero-holder" [ngClass]="{expired: campaignDetail.expired }">
      <div class="hero-bg"></div>
      <div class="hero-content">
        <div class="hero-header">
          <span class="date">{{campaignDetail?.publish_date | dateTranslate:'longMonth':language}}</span>
          <h1 [innerHTML]="campaignDetail?.title"></h1>
          <h2 class="tag" [innerHTML]="campaignDetail?.subtitle"></h2>
        </div>
        <div class="video">
          <p>{{'IMPACT.publicisCampaign.video' | translate}}</p>
          <div (click)="openVideo()">
            <img src="/assets/images/video-player.svg" />
          </div>
        </div>
        <div class="campaign-explanation">
          <ng-container *ngIf="campaignDetail.expired else showCampaignNote">
            {{ 'IMPACT.publicisCampaign.explanationNote.finished' | translate }}
          </ng-container>
          <ng-template #showCampaignNote>
            {{ (campaignDetail?.shareholder ? 'IMPACT.publicisCampaign.explanationNote.shareholder' :
            'IMPACT.publicisCampaign.explanationNote.notShareholder') | translate }}
          </ng-template>
        </div>
        <div class="hero-btns">
          <ng-container *ngIf="campaignDetail?.liked; else showHeroSupportButton">
            <button class="support-button support-button--supported" (click)="engageCampaign('Hero CTA'); ">
              <ion-icon name="heart"></ion-icon>
              {{'IMPACT.publicisCampaign.button.supported' | translate}}
            </button>
            <button class="support-button support-button--green" (click)="shareCampaign('Hero')">
              {{( !campaignDetail.expired ? 'IMPACT.publicisCampaign.button.invite.ongoing' :
              'IMPACT.publicisCampaign.button.invite.finished') | translate}}
            </button>
          </ng-container>
          <ng-template #showHeroSupportButton>
            <button class="support-button" (click)="engageCampaign('Hero CTA')" *ngIf="!campaignDetail.expired">
              {{'IMPACT.publicisCampaign.button.support' | translate}}
            </button>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="campaign-content">
      <h2>{{'IMPACT.publicisCampaign.content.title-1' | translate}}</h2>

      <div class="chart-holder">
        <div class="chart-information">
          <p>{{'IMPACT.publicisCampaign.content.chart1.title' | translate}}</p>
          <h2>{{'IMPACT.publicisCampaign.content.chart1.percentage' | translate}}</h2>
          <p [innerHTML]="'IMPACT.publicisCampaign.content.chart1.description' | translate"></p>
        </div>
        <div class="chart-bg">
          <img src="/assets/images/chart-1-bg.svg" />
        </div>
      </div>

      <h2>{{'IMPACT.publicisCampaign.content.title-2' | translate}}</h2>

      <div class="chart-holder">
        <div class="chart-information chart-white">
          <p>{{'IMPACT.publicisCampaign.content.chart2.title' | translate}}</p>
          <h2>{{'IMPACT.publicisCampaign.content.chart2.percentage' | translate}}</h2>
          <p [innerHTML]="'IMPACT.publicisCampaign.content.chart2.description' | translate"></p>
        </div>
        <div class="chart-bg">
          <img src="/assets/images/chart-2-bg.svg" />
        </div>
      </div>

      <p [innerHTML]="'IMPACT.publicisCampaign.content.p-2' | translate"></p>

      <ng-container *ngIf="campaignDetail?.liked ; else showChartSupportButton">
        <button class="support-button support-button--green" (click)="shareCampaign('After Chart')">
          {{( !campaignDetail.expired ? 'IMPACT.publicisCampaign.button.invite.ongoing' : 'IMPACT.publicisCampaign.button.invite.finished')
          | translate}}
        </button>
      </ng-container>
      <ng-template #showChartSupportButton>
        <button class="support-button" (click)="engageCampaign('After Chart CTA')" *ngIf="!campaignDetail.expired">
          {{'IMPACT.publicisCampaign.button.support' | translate}}
        </button>
      </ng-template>
      <h2 class="green">{{'IMPACT.publicisCampaign.content.title-3' | translate}}</h2>

      <div class="carousel">
        <swiper-container [modules]="swiperModules" [slidesPerView]="1" [spaceBetween]="-20"  [scrollbar]="true">
          <swiper-slide *ngFor="let slide of slides">
            <img [src]="slide.assets" loading="lazy" />
            <div class="swiper-lazy-preloader"></div>
          </swiper-slide>
        </swiper-container>
        <p [innerHTML]="'IMPACT.publicisCampaign.slider.legend' | translate"></p>
      </div>

      <h2>{{'IMPACT.publicisCampaign.content.title-4' | translate}}</h2>
      <p>{{'IMPACT.publicisCampaign.content.p-4' | translate}}</p>
      <div class="logos">
        <div>
          <div class="logo" *ngFor="let i of [0,1]">
            <a [href]="logos[i].link" target="_blank" (click)="trackLogos(logos[i].link)">
              <img [src]="logos[i].assets" />
            </a>
          </div>
        </div>
        <div>
          <div class="logo" *ngFor="let i of [2,3,4]">
            <a [href]="logos[i].link" target="_blank" (click)="trackLogos(logos[i].link)">
              <img [src]="logos[i].assets" />
            </a>
          </div>
        </div>
        <div>
          <div class="logo" *ngFor="let i of [5,6]">
            <a [href]="logos[i].link" target="_blank" (click)="trackLogos(logos[i].link)">
              <img [src]="logos[i].assets" />
            </a>
          </div>
        </div>
        <div class="logo last-one">
          <a [href]="logos[7].link" target="_blank" (click)="trackLogos(logos[7].link)">
            <img [src]="logos[7].assets" />
          </a>
        </div>
      </div>

      <h2 class="green">{{'IMPACT.publicisCampaign.content.title-5' | translate}}</h2>
      <p class="green">{{'IMPACT.publicisCampaign.content.p-5' | translate}}</p>
      <div
        *ngIf="campaignDetail?.supporters_number > 100"
        class="campaign-numbers"
        [innerHTML]="'IMPACT.publicisCampaign.content.supporterNumbers'  | translate: {supporter: campaignDetail?.supporters_number | thousand}"
      ></div>

      <ng-container *ngIf="campaignDetail?.liked ; else showNumbersSupportButton">
        <button class="support-button support-button--green" (click)="shareCampaign('Supporter Numbers')">
          {{( !campaignDetail.expired ? 'IMPACT.publicisCampaign.button.invite.ongoing' : 'IMPACT.publicisCampaign.button.invite.finished')
          | translate}}
        </button>
      </ng-container>
      <ng-template #showNumbersSupportButton>
        <button class="support-button" (click)="engageCampaign('Supporter Numbers CTA')" *ngIf="!campaignDetail.expired">
          {{'IMPACT.publicisCampaign.button.support' | translate}}
        </button>
      </ng-template>

      <!-- FAQ -->
      <h2 [ngStyle]="(!campaignDetail.liked && campaignDetail.expired) && {'margin-top': '80px'}">
        {{'IMPACT.publicisCampaign.faq.title' | translate}}
      </h2>
      <div class="faq-questions">
        <div class="faq-question" *ngFor="let i of [1,2,3,4,5,6,7,8,9]" [ngClass]="{active: selectedFAQIndex === i}">
          <div class="faq-question-header" (click)="setSelectedFAQ(i)">
            {{'IMPACT.publicisCampaign.faq.q'+i +'.title' | translate}}
            <ion-icon [name]="selectedFAQIndex === i ? 'chevron-up' : 'chevron-down'"></ion-icon>
          </div>
          <div class="faq-question-content">
            <span [innerHTML]="'IMPACT.publicisCampaign.faq.q'+i +'.description' | translate"></span>
            <span *ngIf="i === 9">
              &nbsp;
              <a [routerLink]="'/tabs/account/support'">{{'IMPACT.publicisCampaign.faq.q'+i+'.contactUs' | translate}}</a>
              .
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #showLoading>
    <ion-skeleton-text animated class="date"></ion-skeleton-text>
    <ion-skeleton-text animated class="image-holder"></ion-skeleton-text>
    <ion-skeleton-text animated></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 75%"></ion-skeleton-text>
  </ng-template>
</ion-content>
